<template>
  <div>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 65 4.6" style="enable-background:new 0 0 65 4.6;" xml:space="preserve">
    <g>
    <g>
    <path class="st0" d="M1.6,0.2l0.1,0.5C1.6,0.8,1.5,0.9,1.3,1v2.7c0.2,0.1,0.3,0.1,0.3,0.2L1.6,4.4H0.2L0.1,3.9
    c0.1-0.1,0.2-0.1,0.3-0.2V1C0.3,0.9,0.2,0.8,0.1,0.7l0.1-0.5H1.6z"/>
    <path class="st0" d="M2.1,1.4c0.2,0,0.4-0.1,0.6-0.1s0.3,0,0.4,0v0.3c0.1-0.1,0.2-0.2,0.4-0.2C3.7,1.4,3.8,1.3,4,1.3
    c0.4,0,0.7,0.1,0.8,0.3C5,1.8,5,2.1,5,2.6v1.2c0.2,0.1,0.3,0.1,0.3,0.2L5.3,4.4H3.9L3.9,3.9C3.9,3.9,4,3.8,4.2,3.7V2.5
    c0-0.2,0-0.4-0.1-0.4C4,2,3.9,2,3.7,2C3.5,2,3.3,2.1,3.2,2.2v1.5c0.2,0.1,0.3,0.1,0.3,0.2L3.4,4.4H2.1L2,3.9
    c0.1-0.1,0.2-0.1,0.3-0.2V2.1C2.2,2,2.1,1.9,2,1.9L2.1,1.4z"/>
    <path class="st0" d="M5.9,1.3c0-0.4,0.1-0.7,0.3-0.9C6.3,0.1,6.6,0,7,0c0.4,0,0.7,0.1,1,0.3c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.3
    C8,0.9,7.9,1,7.9,1H7.4C7.3,0.9,7.3,0.8,7.3,0.6c0,0-0.1,0-0.1,0c-0.2,0-0.3,0-0.3,0.1C6.8,0.8,6.7,1,6.7,1.2v0.2h0.9V2H6.7v1.7
    C7,3.8,7.2,3.8,7.4,3.9L7.3,4.4H5.6L5.6,3.9c0.1-0.1,0.2-0.1,0.3-0.2V2H5.6L5.6,1.6c0.1-0.1,0.2-0.1,0.3-0.1V1.3z"/>
    <path class="st0" d="M9.2,4.4c-0.5,0-0.8-0.1-1.1-0.4C7.9,3.8,7.8,3.4,7.8,2.9S8,2,8.2,1.7c0.3-0.3,0.6-0.4,1.1-0.4
    c0.5,0,0.8,0.1,1.1,0.4c0.2,0.2,0.3,0.6,0.3,1.1c0,0.5-0.1,0.9-0.4,1.2C10.1,4.3,9.7,4.4,9.2,4.4z M8.7,2.9c0,0.6,0.2,1,0.6,1
    c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.1-0.4,0.1-0.7C9.8,2.3,9.6,2,9.3,2C9.1,2,8.9,2,8.8,2.2C8.7,2.3,8.7,2.5,8.7,2.9z"/>
    <path class="st0" d="M12.8,2.1c-0.3,0-0.5,0.1-0.6,0.2v1.4c0.3,0.1,0.5,0.1,0.7,0.3l-0.1,0.5h-1.7L11,3.9c0.1-0.1,0.2-0.1,0.3-0.2
    V2.1c-0.1,0-0.2-0.1-0.3-0.2l0.1-0.5c0.2,0,0.4-0.1,0.6-0.1s0.3,0,0.4,0v0.4c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.3-0.1,0.4-0.1
    c0.1,0,0.2,0,0.2,0l0,0.8C13,2.1,12.9,2.1,12.8,2.1z"/>
    <path class="st0" d="M13.4,1.4c0.2,0,0.4-0.1,0.6-0.1s0.3,0,0.4,0v0.3c0.1-0.1,0.2-0.1,0.4-0.2c0.1-0.1,0.3-0.1,0.4-0.1
    c0.5,0,0.8,0.1,0.9,0.3c0.1-0.1,0.2-0.2,0.4-0.2c0.2-0.1,0.3-0.1,0.5-0.1c0.4,0,0.7,0.1,0.9,0.3c0.2,0.2,0.2,0.6,0.2,1.1v1
    c0.2,0.1,0.3,0.1,0.3,0.2l-0.1,0.5H17l-0.1-0.5c0.1-0.1,0.2-0.1,0.3-0.2V2.5c0-0.2,0-0.4-0.1-0.4C17.1,2,17,2,16.8,2
    c-0.2,0-0.3,0.1-0.5,0.2c0,0.1,0,0.3,0,0.6v1c0.2,0.1,0.3,0.1,0.3,0.2l-0.1,0.5h-1.4l-0.1-0.5c0.1-0.1,0.2-0.1,0.3-0.2V2.5
    c0-0.2,0-0.4-0.1-0.4C15.3,2,15.2,2,15,2c-0.2,0-0.3,0.1-0.5,0.2v1.5c0.2,0.1,0.3,0.1,0.3,0.2l-0.1,0.5h-1.4l-0.1-0.5
    c0.1-0.1,0.2-0.1,0.3-0.2V2.1c-0.1,0-0.2-0.1-0.3-0.2L13.4,1.4z"/>
    <path class="st0" d="M20,4.4c-0.5,0-0.8-0.1-1.1-0.4c-0.2-0.3-0.4-0.6-0.4-1.1c0-0.3,0-0.6,0.1-0.8c0.1-0.2,0.2-0.4,0.3-0.5
    c0.3-0.2,0.6-0.3,1-0.3c0.4,0,0.7,0.1,0.9,0.3c0.2,0.2,0.3,0.5,0.3,1c0,0.3-0.1,0.4-0.4,0.4h-1.3c0,0.3,0.1,0.4,0.2,0.5
    c0.1,0.1,0.3,0.2,0.5,0.2c0.1,0,0.3,0,0.4,0c0.1,0,0.2-0.1,0.3-0.1l0.1,0l0.2,0.5c0,0-0.1,0.1-0.1,0.1s-0.2,0.1-0.3,0.2
    C20.5,4.4,20.3,4.4,20,4.4z M20.4,2.5c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2-0.1-0.3C20.3,2,20.2,2,20,2c-0.2,0-0.3,0-0.4,0.1
    c-0.1,0.1-0.1,0.3-0.2,0.5L20.4,2.5z"/>
    <path class="st0" d="M23.1,0.1c0.2-0.1,0.4-0.1,0.7-0.1s0.4,0,0.5,0v3.6c0.1,0,0.2,0.1,0.3,0.1v0.5c-0.2,0.1-0.5,0.2-0.9,0.2
    c0,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2s-0.3,0.1-0.4,0.1c-0.4,0-0.7-0.1-0.9-0.4
    c-0.2-0.2-0.3-0.6-0.3-1.1c0-0.6,0.1-1,0.4-1.3c0.3-0.2,0.6-0.3,1-0.3c0.2,0,0.3,0,0.5,0.1V0.8c-0.2-0.1-0.3-0.1-0.4-0.2L23.1,0.1
    z M22.8,3.8c0.2,0,0.4-0.1,0.6-0.2V2C23.2,2,23.1,2,22.9,2c-0.2,0-0.3,0.1-0.4,0.2c-0.1,0.2-0.1,0.4-0.1,0.7c0,0.3,0,0.6,0.1,0.7
    C22.6,3.8,22.7,3.8,22.8,3.8z"/>
    </g>
    <g>
    <path class="st1" d="M47.3,1c-0.1-0.1-0.3-0.1-0.5-0.1S46.3,1,46.1,1.2c-0.1,0.2-0.2,0.6-0.2,1.1c0,0.5,0.1,0.9,0.2,1.1
    c0.1,0.2,0.4,0.3,0.6,0.3c0.4,0,0.8-0.1,1.2-0.2l0.2,0.5c-0.4,0.3-0.9,0.4-1.5,0.4c-0.6,0-1-0.2-1.2-0.5C45.1,3.6,45,3.1,45,2.4
    s0.2-1.3,0.5-1.6c0.3-0.4,0.8-0.5,1.3-0.5c0.5,0,0.9,0.1,1.3,0.4c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.3c0,0.2-0.1,0.3-0.1,0.4h-0.6
    C47.3,1.4,47.3,1.2,47.3,1z"/>
    <path class="st1" d="M48.4,0.1c0.2-0.1,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.5,0v1.5c0.1-0.1,0.2-0.1,0.4-0.2c0.2,0,0.3-0.1,0.4-0.1
    c0.4,0,0.7,0.1,0.8,0.3s0.2,0.5,0.2,0.9v1.2c0.2,0.1,0.3,0.1,0.3,0.2l-0.1,0.5h-1.4l-0.1-0.5c0.1-0.1,0.2-0.1,0.3-0.2V2.5
    c0-0.2,0-0.4-0.1-0.4C50.4,2,50.2,2,50,2c-0.2,0-0.4,0.1-0.5,0.2v1.5c0.2,0.1,0.3,0.1,0.3,0.2l-0.1,0.5h-1.4l-0.1-0.5
    c0.1-0.1,0.2-0.1,0.3-0.2V0.8c-0.1,0-0.2-0.1-0.3-0.2L48.4,0.1z"/>
    <path class="st1" d="M53.3,4.4c-0.5,0-0.8-0.1-1.1-0.4c-0.2-0.3-0.3-0.6-0.3-1.1S52,2,52.3,1.7c0.3-0.3,0.6-0.4,1.1-0.4
    c0.5,0,0.8,0.1,1.1,0.4c0.2,0.2,0.3,0.6,0.3,1.1c0,0.5-0.1,0.9-0.4,1.2S53.8,4.4,53.3,4.4z M52.8,2.9c0,0.6,0.2,1,0.6,1
    c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.1-0.4,0.1-0.7c0-0.6-0.2-0.9-0.6-0.9C53.1,2,53,2,52.9,2.2C52.8,2.3,52.8,2.5,52.8,2.9z"/>
    <path class="st1" d="M55.2,1.4c0.2-0.1,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.5,0v2.4c0.2,0.1,0.3,0.1,0.3,0.2l-0.1,0.5h-1.4l-0.1-0.5
    c0.1-0.1,0.2-0.1,0.3-0.2V2.1c-0.1,0-0.2-0.1-0.3-0.2L55.2,1.4z M55.8,1c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5
    s0.5,0.2,0.5,0.5C56.3,0.8,56.2,1,55.8,1z"/>
    <path class="st1" d="M58.2,2c-0.4,0-0.6,0.3-0.6,0.9c0,0.3,0.1,0.5,0.2,0.7s0.2,0.2,0.4,0.2c0.3,0,0.6,0,0.8-0.1l0.2,0.5
    c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0.1-0.4,0.1-0.6,0.1c-0.9,0-1.3-0.5-1.3-1.5c0-0.6,0.1-1,0.4-1.3c0.3-0.2,0.6-0.3,1-0.3
    s0.7,0.1,1,0.2c0,0,0,0.1,0,0.1c0,0.2-0.1,0.4-0.2,0.6h-0.5c-0.1-0.1-0.1-0.2-0.1-0.4C58.4,2,58.3,2,58.2,2z"/>
    <path class="st1" d="M61,4.4c-0.5,0-0.8-0.1-1.1-0.4c-0.2-0.3-0.4-0.6-0.4-1.1c0-0.3,0-0.6,0.1-0.8C59.7,2,59.9,1.8,60,1.7
    c0.3-0.2,0.6-0.3,1-0.3c0.4,0,0.7,0.1,0.9,0.3c0.2,0.2,0.3,0.5,0.3,1c0,0.3-0.1,0.4-0.4,0.4h-1.3c0,0.3,0.1,0.4,0.2,0.5
    c0.1,0.1,0.3,0.2,0.5,0.2c0.1,0,0.3,0,0.4,0c0.1,0,0.2-0.1,0.3-0.1l0.1,0l0.2,0.5c0,0-0.1,0.1-0.1,0.1s-0.2,0.1-0.3,0.2
    C61.4,4.4,61.2,4.4,61,4.4z M61.4,2.5c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2-0.1-0.3C61.2,2,61.1,2,60.9,2s-0.3,0-0.4,0.1
    c-0.1,0.1-0.1,0.3-0.2,0.5L61.4,2.5z"/>
    <path class="st1" d="M63.6,1.9c-0.3,0-0.4,0.1-0.4,0.2c0,0.1,0.1,0.3,0.4,0.3l0.5,0.1c0.5,0.1,0.7,0.4,0.7,0.8
    c0,0.3-0.1,0.5-0.3,0.7s-0.5,0.3-1,0.3c-0.5,0-0.8-0.1-1.1-0.2c0,0,0-0.1,0-0.1c0-0.2,0-0.4,0.1-0.6h0.5c0.1,0.1,0.1,0.2,0.1,0.3
    c0.1,0,0.2,0,0.3,0c0.4,0,0.5-0.1,0.5-0.3c0-0.1,0-0.1-0.1-0.2s-0.1-0.1-0.3-0.1l-0.5-0.1C63,3.1,62.8,3,62.7,2.8
    c-0.1-0.1-0.2-0.3-0.2-0.6s0.1-0.5,0.3-0.6c0.2-0.2,0.5-0.3,0.9-0.3c0.4,0,0.7,0.1,1,0.2c0,0,0,0.1,0,0.1c0,0.2,0,0.4-0.1,0.6
    h-0.5C64,2.1,64,2,64,1.9C63.9,1.9,63.7,1.9,63.6,1.9z"/>
    </g>
    </g>
    <g>
    <path class="st2" d="M32.1,2.4C32.1,2.4,32.1,2.4,32.1,2.4c0-0.1,0-0.2-0.1-0.3C32,2,31.9,2,31.7,2s-0.3,0-0.4,0.1
    c0,0-0.1,0.1-0.1,0.2"/>
    <path class="st2" d="M39,4.4c-0.3,0-0.5-0.1-0.7-0.2c-0.1-0.1-0.2-0.3-0.2-0.6V1.9h-0.3l-0.1-0.4c0.1-0.1,0.2-0.2,0.4-0.2
    c0-0.3,0.2-0.5,0.3-0.7H39v0.8h0.9v0.5H39v1.5c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.1,0.3,0.1s0.3,0,0.4-0.1L40,4.2
    C39.7,4.4,39.4,4.4,39,4.4z M43.4,4.4H42L42,4c0.1-0.1,0.2-0.1,0.3-0.2V2.6c0-0.2,0-0.4-0.1-0.4C42.1,2.1,42,2,41.8,2
    c-0.2,0-0.4,0.1-0.5,0.2v1.5c0.2,0.1,0.3,0.1,0.3,0.2l-0.1,0.5h-1.4L40.1,4c0.1-0.1,0.2-0.1,0.3-0.2V0.8c-0.1,0-0.2-0.1-0.3-0.2
    l0.1-0.5c0.2-0.1,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.5,0v1.5c0.1-0.1,0.2-0.1,0.4-0.2c0.2,0,0.3-0.1,0.4-0.1c0.4,0,0.7,0.1,0.8,0.3
    c0.2,0.2,0.2,0.5,0.2,0.9v1.2c0.2,0.1,0.3,0.1,0.3,0.2L43.4,4.4z"/>
    <path class="st2" d="M34,3.5c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.3,0.1c0.2,0,0.4-0.1,0.5-0.2V3.2h-0.4C34.2,3.2,34,3.3,34,3.5z
    "/>
    <g>
    <path class="st0" d="M27.4,2.5h1.3v0.1c0.2-0.1,0.4-0.1,0.7-0.2c0.1,0,0.1,0,0.2,0V1c0.2-0.1,0.3-0.1,0.3-0.2l-0.1-0.5h-1.4
    l-0.1,0.5c0.1,0.1,0.2,0.1,0.3,0.2v0.9h-1.3V1c0.2-0.1,0.3-0.1,0.3-0.2l-0.1-0.5h-1.4l-0.1,0.5c0.1,0.1,0.2,0.1,0.3,0.2v2.7
    c0.3-0.2,0.6-0.3,0.9-0.5V2.5z"/>
    <path class="st1" d="M26.3,3.9l0.1,0.5h1.4l0.1-0.5c-0.1-0.1-0.2-0.1-0.3-0.2V3.2c-0.3,0.1-0.5,0.3-0.9,0.5v0.1
    C26.4,3.8,26.3,3.9,26.3,3.9z"/>
    <path class="st1" d="M28.8,2.7v1.1c-0.2,0.1-0.3,0.1-0.3,0.2l0.1,0.5h1.4L30,3.9c-0.1-0.1-0.2-0.1-0.3-0.2V2.5c-0.1,0-0.1,0-0.2,0
    C29.2,2.6,29,2.6,28.8,2.7z"/>
    </g>
    <g>
    <path class="st0" d="M31.2,2.3c0-0.1,0.1-0.1,0.1-0.2C31.4,2.1,31.6,2,31.7,2S32,2,32,2.1c0.1,0.1,0.1,0.2,0.1,0.3c0,0,0,0,0,0
    c0.3,0,0.5,0.1,0.8,0.1c0-0.4-0.1-0.7-0.3-0.8c-0.2-0.2-0.5-0.3-0.9-0.3c-0.4,0-0.7,0.1-1,0.3c-0.1,0.1-0.3,0.3-0.3,0.5
    c0,0,0,0.1,0,0.2C30.7,2.3,31,2.3,31.2,2.3z"/>
    <path class="st1" d="M30.7,4.1c0.2,0.3,0.6,0.4,1.1,0.4c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.3-0.1,0.3-0.2s0.1-0.1,0.1-0.1l-0.2-0.5
    l-0.1,0c-0.1,0-0.1,0.1-0.3,0.1c-0.1,0-0.3,0-0.4,0c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5h1.3c0.3,0,0.4-0.1,0.4-0.4
    c0-0.1,0-0.1,0-0.2c-0.3,0-0.5-0.1-0.8-0.1c0,0.1,0,0.1,0,0.2l-0.9,0c0-0.1,0-0.2,0.1-0.3c-0.3,0-0.5,0-0.9,0
    c-0.1,0.2-0.1,0.4-0.1,0.6C30.3,3.5,30.4,3.8,30.7,4.1z"/>
    </g>
    <g>
    <path class="st0" d="M35.5,1.6c-0.2-0.2-0.5-0.2-0.9-0.2c-0.4,0-0.8,0.1-1.2,0.3c0,0.1,0,0.1,0,0.2c0,0.2,0,0.4,0.1,0.5H34
    c0-0.1,0.1-0.2,0.1-0.4c0.1,0,0.2,0,0.3,0c0.3,0,0.5,0.1,0.5,0.4c0.3-0.1,0.6-0.1,0.8-0.2C35.7,1.9,35.6,1.7,35.5,1.6z"/>
    <path class="st1" d="M34.9,2.8h-0.7c-0.4,0-0.6,0.1-0.8,0.2c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.3,0.1,0.5,0.3,0.6
    c0.2,0.2,0.4,0.2,0.7,0.2c0.5,0,0.8-0.1,0.9-0.4c0,0.1,0.1,0.3,0.1,0.4c0.4,0,0.7,0,0.9-0.1V3.8c-0.1,0-0.2-0.1-0.3-0.1V2.4
    c0-0.1,0-0.2,0-0.3c-0.3,0.1-0.5,0.2-0.8,0.2c0,0,0,0.1,0,0.1V2.8z M34.9,3.7c-0.1,0.1-0.3,0.2-0.5,0.2c-0.1,0-0.2,0-0.3-0.1
    C34.1,3.7,34,3.6,34,3.5c0-0.2,0.1-0.3,0.4-0.3h0.4V3.7z"/>
    </g>
    <g>
    <path class="st0" d="M37.4,0.1c-0.1,0-0.3,0-0.5,0c-0.2,0-0.4,0-0.6,0.1l-0.1,0.5c0.1,0.1,0.2,0.2,0.3,0.2v0.9
    c0.3-0.1,0.6-0.3,0.8-0.5V0.1z"/>
    <path class="st1" d="M36.2,4l0.1,0.5h1.4L37.7,4c-0.1-0.1-0.2-0.1-0.3-0.2V1.3c-0.3,0.2-0.5,0.3-0.8,0.5v2
    C36.4,3.8,36.3,3.9,36.2,4z"/>
    </g>
    <path class="st1" d="M39.4,3.8c-0.1,0-0.2,0-0.3-0.1c0-0.1-0.1-0.2-0.1-0.3V1.9h0.9V1.4H39V0.7h-0.4c-0.2,0.1-0.3,0.3-0.3,0.7
    c-0.2,0.1-0.3,0.2-0.4,0.2l0.1,0.4h0.3v1.7c0,0.3,0.1,0.5,0.2,0.6c0.1,0.1,0.3,0.2,0.7,0.2c0.3,0,0.6-0.1,0.9-0.2l-0.2-0.5
    C39.6,3.8,39.5,3.8,39.4,3.8z"/>
    <path class="st1" d="M43.1,2.6c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.2-0.4-0.3-0.8-0.3c-0.1,0-0.3,0-0.4,0.1c-0.2,0-0.3,0.1-0.4,0.2V0.1
    c-0.1,0-0.3,0-0.5,0c-0.2,0-0.4,0-0.6,0.1l-0.1,0.5c0.1,0.1,0.2,0.2,0.3,0.2v2.9c-0.2,0.1-0.3,0.1-0.3,0.2l0.1,0.5h1.4L41.6,4
    c-0.1-0.1-0.2-0.1-0.3-0.2V2.2C41.5,2.1,41.6,2,41.8,2c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4v1.2C42.1,3.8,42,3.9,42,4
    L42,4.4h1.4L43.5,4c-0.1-0.1-0.2-0.1-0.3-0.2V2.6z"/>
    </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'logo',
  data () {
    return {}
  }
}
</script>

<style type="text/css" scoped>
  svg {
    width:20rem;
  }
  .st0{fill:#26A9E0;}
  .st1{fill:#343333;}
  .st2{fill:none;}
  @media (max-width: 767px) {
    svg {
      width:10rem;
    }
  }
</style>
